// extracted by mini-css-extract-plugin
module.exports = {"titleAndDescCont":"titleAndDescCont___3Yib3"};